"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unlockScroll = exports.lockScroll = exports.scrollToElement = exports.exec = void 0;
var throttle_debounce_1 = require("throttle-debounce");
var ScrollMagic = require("ScrollMagic");
function exec() {
    /*
     * Scroll
     */
    var clickLinkHandler = function (e) {
        e.preventDefault();
        var anchor = e.currentTarget;
        var fragment = anchor.hash;
        var target = fragment ? document.querySelector(fragment) : null;
        if (fragment !== '#top' && !target) {
            return;
        }
        if (fragment === '#top') {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }
        else {
            (0, exports.scrollToElement)(target);
        }
        if (!('noHistory' in anchor.dataset)) {
            history.pushState(null, '', fragment);
        }
        return false;
    };
    document.querySelectorAll('a[href*="#"]:not([data-scroll~="noscroll"])').forEach(function (anchor) {
        if ((anchor.protocol !== '' && anchor.protocol !== location.protocol) ||
            (anchor.host !== '' && anchor.host !== location.host) ||
            (anchor.pathname !== '' && anchor.pathname !== location.pathname) ||
            (anchor.search !== location.search)) {
            return;
        }
        anchor.addEventListener('click', clickLinkHandler);
    });
    /*
     * vw, vh
     */
    var handleWindowResize = function () {
        var vwi = document.documentElement.clientWidth / 100;
        var vhi = document.documentElement.clientHeight / 100;
        document.documentElement.style.setProperty('--vwi', "".concat(vwi, "px"));
        document.documentElement.style.setProperty('--vhi', "".concat(vhi, "px"));
    };
    window.addEventListener('resize', handleWindowResize, { passive: true });
    handleWindowResize();
    /*
     * Menu
     */
    var menu = document.querySelector('#site-header');
    var menuButton = menu.querySelector('.menu-button');
    var globalNav = menu.querySelector('nav ul');
    var mqlMenu = window.matchMedia('(min-width:1200px)');
    var timerID = null;
    menuButton.addEventListener('click', function (e) {
        e.preventDefault();
        menu.classList.toggle('opened');
        menu.classList.add('touched');
        if (menu.classList.contains('opened')) {
            timerID = setTimeout(exports.lockScroll, 500);
        }
        else {
            (0, exports.unlockScroll)();
            if (timerID) {
                clearTimeout(timerID);
                timerID = null;
            }
        }
    });
    var onClickMenuItem = function (e) {
        menu.classList.remove('opened');
        (0, exports.unlockScroll)();
    };
    menu.querySelectorAll('nav ul a').forEach(function (element) {
        element.addEventListener('click', onClickMenuItem, true);
    });
    var onMediaQueryChangeMenu = function (e) {
        menu.classList.remove('opened');
        menu.classList.remove('touched');
        (0, exports.unlockScroll)();
        globalNav.querySelectorAll('li').forEach(function (element) {
            var anchor = element.querySelector('a');
            var style = window.getComputedStyle(anchor);
            var paddingLeft = parseFloat(style.paddingLeft);
            var paddingRight = parseFloat(style.paddingRight);
            globalNav.style.setProperty("--".concat(element.classList[0], "-width"), (anchor.offsetWidth - paddingLeft - paddingRight) + 'px');
            globalNav.style.setProperty("--".concat(element.classList[0], "-left"), (anchor.offsetLeft + paddingLeft) + 'px');
        });
    };
    mqlMenu.addEventListener('change', onMediaQueryChangeMenu);
    onMediaQueryChangeMenu(mqlMenu);
    /*
     * ScrollMagic
     */
    var controller = new ScrollMagic.Controller();
    var onMediaQueryChangeScroll = function (e) {
        if (mqlMenu.matches) {
            controller.enabled(true);
            controller.update(true);
        }
        else {
            controller.enabled(false);
        }
    };
    mqlMenu.addEventListener('change', onMediaQueryChangeScroll);
    onMediaQueryChangeScroll(mqlMenu);
    ['about', 'howto', 'application', 'support'].forEach(function (selector) {
        var element = document.querySelector("#".concat(selector));
        var target = document.querySelector("#site-header nav ul li.".concat(selector));
        new ScrollMagic.Scene({
            triggerElement: element,
            triggerHook: 0,
            offset: -101,
            duration: function () { return element.offsetHeight; },
            reverse: true,
        })
            .setClassToggle(target, 'enter')
            .addTo(controller);
    });
    new ScrollMagic.Scene({
        triggerElement: document.querySelector('#site-footer'),
        triggerHook: 0,
        offset: -101,
        reverse: true,
    })
        .setClassToggle(globalNav, 'enter-footer')
        .addTo(controller);
}
exports.exec = exec;
;
var scrollToElement = function (element, options) {
    if (options === void 0) { options = {}; }
    var _a = options.keepOffset, keepOffset = _a === void 0 ? true : _a, callback = options.callback;
    var offset = 0;
    if (keepOffset) {
        var header = document.querySelector('[data-header]');
        if (header) {
            offset -= header.offsetHeight;
        }
        if (element.dataset.offset) {
            offset += parseInt(element.dataset.offset);
        }
    }
    var rect = element.getBoundingClientRect();
    var left = rect.left + window.pageXOffset;
    var top = rect.top + window.pageYOffset;
    window.scrollTo({ top: top + offset, left: left, behavior: 'smooth' });
    if (Math.abs(window.scrollX - left) < 1 && Math.abs(window.scrollY - (top + offset)) < 1) {
        return new Promise(function (resolve) { return resolve(); });
    }
    else {
        return new Promise(function (resolve) {
            var handler = (0, throttle_debounce_1.debounce)(100, function (e) {
                window.removeEventListener('scroll', handler);
                resolve();
            });
            window.addEventListener('scroll', handler, { passive: true });
        });
    }
};
exports.scrollToElement = scrollToElement;
var lockScroll = function () {
    var html = document.querySelector('html');
    if (html.style.position !== 'fixed') {
        var scrollY_1 = window.scrollY;
        html.style.position = 'fixed';
        html.style.left = '0';
        html.style.right = '0';
        html.style.top = "".concat(-scrollY_1, "px");
    }
};
exports.lockScroll = lockScroll;
var unlockScroll = function () {
    var html = document.querySelector('html');
    if (html.style.position === 'fixed') {
        var scrollY_2 = -parseFloat(html.style.top);
        html.style.position = '';
        html.style.left = '';
        html.style.right = '';
        html.style.top = '';
        html.scrollTo(0, scrollY_2);
    }
};
exports.unlockScroll = unlockScroll;
